var React = require('react');

function LocationPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 .5C4.3.5 2.1 2.7 2.1 5.4c0 3.1 3.5 7 4.1 7.6.2.2.4.5.8.5s.6-.2.8-.5c.6-.6 4.1-4.5 4.1-7.6C11.9 2.7 9.7.5 7 .5zm0 8.1c-1.8 0-3.3-1.5-3.3-3.3S5.2 2.1 7 2.1s3.3 1.5 3.3 3.3S8.8 8.6 7 8.6zm0-4.8c-.9 0-1.6.7-1.6 1.6S6.1 7 7 7s1.6-.7 1.6-1.6S7.9 3.8 7 3.8z"}));
}

LocationPin.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = LocationPin;

LocationPin.default = LocationPin;
